import middleware from "../../middleware";
import api from "../../service";

class StudentService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/students`;
	}

	async getAll() {
		const { data } = await api.get(`${this.url}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
				active: "active",
			},
		});
		return data;
	}

	async get(id) {
		const { data } = await api.get(`${this.url}/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return data;
	}
	async getbydepartmentid(dep_id) {
		const { data } = await api.get(`${this.url}/department/${dep_id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return data;
	}
	async getstudents(dep_id) {
		const { data } = await api.get(`${this.url}/department/${dep_id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return data;
	}
}

export default StudentService;
